import React from 'react';
import { Route, Switch, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Icon } from 'antd';
import { resetSection } from 'redux-form';
import { setToken } from 'services/axios';
import { checkLocalAuthAction, loginSuccessAction } from 'store/auth/action';
import { loadListPatientKinAction } from 'store/account/action';
import { checkAuthenticationStatus } from 'store/auth/selector';
import { PATHS } from 'common/enum';
import Layout from 'components/Layout';
import { BookingFormId } from 'model/booking';
import AuthLayout from 'components/Layout/AuthLayout';

const Booking = React.lazy(() => import('components/Booking'));
const Login = React.lazy(() => import('components/Auth'));
const PasswordRecovery = React.lazy(() =>
  import('components/Auth/PasswordRecovery'),
);
const VerificationCode = React.lazy(() =>
  import('components/Auth/VerificationChangePassword'),
);
const ChangePassword = React.lazy(() =>
  import('components/Auth/ChangePassword'),
);

const ViewBookings = React.lazy(() => import('components/ViewBookings'));
const ViewBookingFromLink = React.lazy(() =>
  import('components/ViewBookings/ViewBookingFromLink'),
);

const routes = [
  { path: PATHS.LOGIN, component: Login },
  { path: PATHS.PASSWORD_RECOVERY, component: PasswordRecovery },
  { path: PATHS.VERIFICATION_CODE, component: VerificationCode },
  { path: PATHS.CHANGE_PASSWORD, component: ChangePassword },
  { path: PATHS.VIEW_BOOKINGS, component: ViewBookings, type: 'view-booking' },
  { path: PATHS.VIEW_BOOKING, component: ViewBookingFromLink },
  { path: PATHS.ROOT, component: Booking, type: 'booking' },
];

class Routing extends React.Component {
  state = {
    _isAuthenticated: false,
  };

  componentDidUpdate(prevProps) {
    const {
      authStatus: { isAuthenticated, data },
    } = this.props;

    const {
      authStatus: { data: prevData },
    } = prevProps;

    if (data && data !== prevData) {
      setToken(data.token);
      this.setState({ _isAuthenticated: isAuthenticated });
    }
  }

  componentDidMount() {
    const {
      checkLocalAuth,
      loginSuccess,
      resetSection,
      authStatus: { isAuthenticated, data },
    } = this.props;

    this.setState({ _isAuthenticated: isAuthenticated }, () => {
      if (isAuthenticated && data) {
        loginSuccess(data);
      } else {
        checkLocalAuth();
      }
    });

    window.addEventListener('storage', function(e) {
      if (e.key === 'AUTH_INFO') {
        const oldAuth = JSON.parse(e.oldValue);
        const newAuth = JSON.parse(e.newValue);
        if (oldAuth.patientId !== newAuth.patientId) {
          if (oldAuth.patientId && !newAuth.patientId) {
            resetSection('s4', 's5');
          }
          window.location.reload();
        }
      }
    });
  }

  renderRouteComponent = (Component, type) => props => {
    if (type === 'booking') {
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    } else if (type === 'view-booking') {
      return <Component {...props} />;
    } else {
      return (
        <AuthLayout>
          <Component {...props} />
        </AuthLayout>
      );
    }
  };

  renderRoutes() {
    return routes.map(route => {
      return (
        <Route
          key={route.path}
          path={route.path}
          render={this.renderRouteComponent(route.component, route.type)}
        />
      );
    });
  }

  render() {
    const { _isAuthenticated } = this.state;

    return (
      <React.Suspense fallback={<Icon type="loading" />}>
        {_isAuthenticated && <Switch>{this.renderRoutes()}</Switch>}
      </React.Suspense>
    );
  }
}

const mapStateToProps = state => ({
  authStatus: checkAuthenticationStatus(state),
});

const mapDispatchToProps = dispatch => {
  return {
    checkLocalAuth: () => dispatch(checkLocalAuthAction()),
    loginSuccess: options => dispatch(loginSuccessAction(options)),
    loadListPatientKin: options => dispatch(loadListPatientKinAction(options)),
    resetSection: (...sections) =>
      dispatch(resetSection(BookingFormId, ...sections)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Routing));
